export type StatusTone = "success" | "error" | "warning" | "info" | "processing" | "draft";

const STATUS_TONES: Record<string, StatusTone> = {
  paid: "success",
  credit: "success",
  overpaid: "success",
  partial: "info",
  unpaid: "warning",
  pending: "warning",
  overdue: "error",
  processing: "processing",
};

export function statusTone(status: string | null | undefined): StatusTone {
  return STATUS_TONES[status?.toLowerCase() ?? ""] ?? "draft";
}
